var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon example "
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.09375 20.5573V4.99688H7.17292V4.76771C7.20347 3.72882 7.58924 2.85417 8.33021 2.14375C9.07118 1.43333 9.96111 1.07812 11 1.07812C12.0389 1.07812 12.9288 1.43333 13.6698 2.14375C14.4108 2.85417 14.7965 3.72882 14.8271 4.76771V4.99688H18.9292V20.5573H3.09375ZM9.35 4.76771V4.99688H12.65V4.76771C12.6194 4.33993 12.4476 3.97708 12.1344 3.67917C11.8212 3.38125 11.4431 3.23229 11 3.23229C10.5569 3.23229 10.1788 3.38125 9.86562 3.67917C9.55243 3.97708 9.38056 4.33993 9.35 4.76771ZM5.24792 18.4031H16.7521V7.17396H14.8271V9.92396H12.6729V7.17396H9.32708V9.92396H7.17292V7.17396H5.24792V18.4031ZM5.24792 18.4031V7.17396V18.4031Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBagIcon);
export default __webpack_public_path__ + "static/media/shopping-bag-icon.5f4825f758c8d29b0e1e6bdb149766c8.svg";
export { ForwardRef as ReactComponent };